const appReadyAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const { config: { locale, configGamePk, appContext, stitchEnv } = {} } = state;
        const dataParams = { gamePk: configGamePk, locale, appContext };
        if (stitchEnv) {
            dataParams.stitchEnv = stitchEnv;
        }
        return Promise.allSettled([
            componentDataEngine.fetch('productConfig', dataParams),
            componentDataEngine.gameReady()
        ]).then(([productConfigRes]) => {
            const res = productConfigRes?.value;
            if (res) {
                componentDataEngine.store(res);
            }
        });
    };
};

export default appReadyAction;
